<template>
  <div class="warp">
    <div class="z-flex determine-status">
      <div class="title">处方ID：</div>
      <!-- <div>{{ serialNumberList.join('，') }}</div> -->
      <template v-for="(serialNumber, index) in serialNumberList" :key="index">
        <a-button size="small" @click="openPrescribe()" type="link">
          {{ serialNumber }}
        </a-button>
      </template>
    </div>
    <div class="z-flex determine-status determine-status-radio">
      <div class="title">疗效判定：</div>
      <div class="status-list">
        <a-radio-group
          class="z-flex"
          v-model:value="determineResult"
          :options="judgeOptions"
          @change="handleChange"
        ></a-radio-group>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useStore } from 'vuex'
import { defineProps, ref, onMounted, defineEmits } from 'vue'
import { judgeOptions } from './config'
import { getDetermineSerialNumbers, getSerialListByfollID } from '@/api/workPlace/prescription'
const store = useStore()
const props = defineProps({
  prescriptInfo: {
    type: Object,
    default: () => {}
  }
})
const determineResult = ref(null)
const emits = defineEmits(['prescriptResultChange', 'cancel'])
const serialNumberList = ref([])
function handleChange(e) {
  const val = e.target.value
  emits('prescriptResultChange', val)
}
// 查询关联处方(处方详情)
function getAssociatedSerialNumbersByser(serialNumber) {
  getDetermineSerialNumbers({ serialNumber })
    .then(res => {
      serialNumberList.value = res
    })
    .catch(() => {
      serialNumberList.value = []
    })
}
// 查询关联处方(工单处理)
function getAssociatedSerialNumbersBywork(followupPlanId) {
  getSerialListByfollID({ followupPlanId })
    .then(res => {
      serialNumberList.value = res.finalDeterminedSerialNumbers || []
    })
    .catch(() => {
      serialNumberList.value = []
    })
}
// 打开处方
function openPrescribe() {
  store.commit('app/SET_TABS_ACTIVE', 'prescription')
  emits('cancel')
}
onMounted(() => {
  const { operationSource, serialNumber, effectivenessResult, followupPlanId } = props.prescriptInfo
  switch (operationSource) {
    // 0 是修改，1是处方详情里面判断 ，2是工单里面判断
    case 0:
      serialNumberList.value = [serialNumber]
      break
    case 1:
      getAssociatedSerialNumbersByser(serialNumber)
      break
    default:
      getAssociatedSerialNumbersBywork(followupPlanId)
      break
  }
  determineResult.value = effectivenessResult || null
})
</script>
<style scoped lang="scss">
.determine-status {
  justify-content: flex-start;
  &-radio {
    margin-top: 14px;
  }
  .title {
    width: 70px;
    margin-right: 8px;
    text-align: right;
    flex-shrink: 0;
  }
}
</style>
